import { i18nMark } from 'lingui-react';

const messages = {
  additionalWarnings: i18nMark('Additional Warnings'),
  componentId: i18nMark('Component Id'),
  count: i18nMark('Count'),
  datetime: i18nMark('Date/Time'),
  ecu: i18nMark('ECU'),
  fmi: i18nMark('FMI'),
  status: i18nMark('Status'),
  viewRepairInstructions: i18nMark('View Repair Instructions'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/messages.js